import { Button, createStyles, IconButton, makeStyles, styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles((theme) =>
  createStyles({
    mainCont: {
      display: 'flex',
      [theme.breakpoints.down(960)]: {
        flexDirection: 'column',
      },
    },
    root: {
      // marginLeft: 10,
      height: 'fit-content',
      display: 'flex',
      flexWrap: 'nowrap',
      gap: 10,
      alignItems: 'flex-start',
      width: '100%',
      border: theme.palette.type === 'dark' ? '1px solid #2d343e' : `1px solid ${COLORS.LIGHT_BORDER}`,
      borderRadius: 8,
      padding: 10,
      backgroundImage:
        theme.palette.type === 'dark'
          ? `linear-gradient(270deg, rgba(18,18,25,0.6) 0%, rgba(13,18,25,1) 30%), url(/casting-background.png)`
          : `linear-gradient(270deg, rgba(255,255,255,0.5) 0%, rgba(255,255,255,1) 30%), url(/casting-background.png)`,
      backgroundSize: 'auto 100%',

      [theme.breakpoints.down(960)]: {
        backgroundImage:
          theme.palette.type === 'dark'
            ? 'linear-gradient(0deg, rgba(18,18,25,0.9) 0%, rgba(13,18,25,1) 50%), url(/casting-background.png)'
            : `linear-gradient(0deg , rgba(255,255,255,0.5) 0%, rgba(255,255,255,1) 30%), url(/casting-background.png)`,
        flexDirection: 'column',
        alignItems: 'start',
      },
      '& .MuiFormControl-root': {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    qrContainer: {
      height: 43,
      width: 100,
      background: theme.palette.type === 'dark' ? '#0a0b15' : COLORS.WHITE + '!important',
      border: `1px solid ${COLORS.PRIMARY}`,
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      cursor: 'pointer',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      [theme.breakpoints.down(960)]: {
        width: 100,
        height: 70,
        alignSelf: 'center',
      },
    },
    input: {
      width: 400,
      '& .MuiInputBase-root': {
        height: '44px!important',
        '& fieldset': {
          borderRadius: 8,
          border: 'solid 1px #2d343e',
        },
      },

      '& .MuiInputAdornment-positionStart': {
        marginRight: 15,
      },

      '& .MuiSvgIcon-root': {
        fontSize: 20,
      },

      '& input::placeholder': {
        color: '#60718b',
        letterSpacing: 0.4,
        fontWeight: 500,
        opacity: 0.9,
      },

      '& .MuiFormHelperText-root': {
        color: COLORS.ERROR,
        fontSize: 14,
      },

      [theme.breakpoints.down(960)]: {
        width: '100%',
      },
    },
    buttonCls: {
      width: 160,
      height: '44px !important',
      borderRadius: 8,
      textTransform: 'unset',
      fontSize: 15,
      [theme.breakpoints.down(960)]: {
        width: '100%',
      },
      '&:disabled': {
        backgroundColor: theme.palette.type === 'dark' ? '#ffffff1f' : COLORS.LIGHT_BACKGROUND,
        color: theme.palette.type === 'dark' ? '#ffffff4d' : 'gray',
      },
    },
  }),
);

export const PastContainer = styled(Button)(({ theme }) => ({
  background: '#242b35',
  borderRadius: 8,
  width: '100%',
  minWidth: 400,
  '& > span': {
    display: 'flex',
    alignItems: 'center',
    gap: 15,
  },

  padding: '10px 15px',
}));

export const PastCount = styled('div')(({ theme }) => ({
  height: 31,
  width: 31,
  borderStyle: 'solid',
  borderWidth: '2px',
  borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
  borderImageSlice: '1',
  backgroundImage: 'linear-gradient(to bottom, #242b35, #242b35), linear-gradient(253deg, #d51bff, #00d4ff)',
  backgroundOrigin: 'border-box',
  backgroundClip: 'content-box, border-box',
  borderRadius: '25px !important',
  WebkitBorderRadius: '25px !important',
  WebkitMaskImage: '-webkit-radial-gradient(circle, white 100%, black 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const PastTextContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '& > p': {
    lineHeight: 1.2,
  },
}));

export const CustomIconButton = styled(IconButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginLeft: 'auto',

  '& .MuiSvgIcon-root': {
    width: 11,
    height: 11,
  },

  '&:hover': {
    backgroundColor: 'unset',
  },
}));
